import { render, staticRenderFns } from "./pdf2.vue?vue&type=template&id=55fb7452&scoped=true"
import script from "./pdf2.vue?vue&type=script&lang=js"
export * from "./pdf2.vue?vue&type=script&lang=js"
import style0 from "./pdf2.vue?vue&type=style&index=0&id=55fb7452&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fb7452",
  null
  
)

export default component.exports